// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"12addbba","239":"9a242b5c","455":"0152101d"}[chunkId] + ".chunk.js";
};